import { gql } from '@apollo/client';

export const PUBLICATION_QUERY = gql`
  query GetPublication($pubId: String!) {
    publicationsExp(pubId: $pubId) {
      edges {
        node {
          pubId
          id
          doi
          title
          authors
          journal
          number
          pages
          year
        }
      }
    }
  }
`;

export const MATERIALS_QUERY = gql`
  query GetMaterials($pubId: String!) {
    materials(pubId: $pubId) {
      edges {
        node {
          pubId
          matId
          composition
          morphology
          spaceGroup
          latticeParameter
          icsdIds
          arrangement
        }
      }
    }
  }
`;

export const ECHEMICAL_QUERY = gql`
  query GetEchemical($sampleId: Int!) {
    echemical(sampleId: $sampleId) {
      edges {
        node {
          current
          potential
          cvtype
        }
      }
    }
  }
`;

  

export const SAMPLES_BY_MATID_QUERY = gql`
  query GetSamples($matId: Int!) {
    samples(matId: $matId) {
      edges {
        node {
          matId
          data
          pubId
          sampleId
        }
      }
    }
  }
`;

export const XRD_QUERY = gql`
  query XRDData($matId: Int!) {
    xrd(matId: $matId) {
      edges {
        node {
          degree
          intensity
        }
      }
    }
  }
`;

export const XPS_QUERY = gql`
  query XPSData($matId: Int!) {
    xps(matId: $matId) {
      edges {
        node {
          bindingEnergy
          intensity
        }
      }
    }
  }
`;

export const MATERIALS_DATA_QUERY = gql`
  query GetMaterials {
    materials {
      edges {
        node {
          spaceGroup
          composition
          latticeParameter
          matId
          pubId
          morphology
          arrangement
          icsdIds
        }
      }
    }
  }
`;

export const SAMPLES_BY_PUBID_QUERY = gql`
  query GetSamplesByPubId($pubId: String!) {
    samples(pubId: $pubId) {
      totalCount
      edges {
        node {
          sampleId
          matId
          data
        }
      }
    }
  }
`;

export const SAMPLES_QUERY = gql`
  query GetSamples {
    samples {
      totalCount
      edges {
        node {
          matId
          sampleId
          data
        }
      }
    }
  }
`;